
























































import { Component, Vue, Provide, Prop } from "vue-property-decorator";

@Component({
  name: "orderDeal",
  components: {}
})
export default class CombinationProperty extends Vue {
  @Prop() basicInfo: any;
  @Prop() imgsInfo: any;
  private mounted() {
  }
}
